import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { withTransientProps } from "core/utils/transientProps";

export interface GraphMenuSectionProps {
  /** The title of the section */
  title: string;
  /** Whether the section is currently expanded. */
  expanded: boolean;
  /** A callback function which is fired when the accordion is clicked.
   * It provides the expected new state of the expanded property. */
  onToggleExpanded?: (expanded: boolean) => void;
  /** Turn on-off the accordion padding for UI */
  compact?: boolean;
}

/** A section within a graph menu */
export const GraphMenuSection = ({
  title,
  expanded,
  onToggleExpanded = () => {},
  compact,
  children
}: React.PropsWithChildren<GraphMenuSectionProps>): JSX.Element => {
  return (
    <AccordionWrapper>
      <Accordion
        elevation={0}
        expanded={expanded}
        onChange={(event, expanded) => onToggleExpanded(expanded)}
        square
      >
        <AccordionSummary expandIcon={<ArrowDropDown />}>
          <Typography variant="body2">{title}</Typography>
        </AccordionSummary>
        <PaddingSwitchDetails $compact={compact}>
          {children}
        </PaddingSwitchDetails>
      </Accordion>
    </AccordionWrapper>
  );
};

const AccordionWrapper = styled("div")`
  .MuiAccordion-root.Mui-expanded {
    margin: auto;
  }

  .MuiAccordionSummary-root.Mui-expanded {
    min-height: unset;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: auto;
  }
`;

const PaddingSwitchDetails = styled(AccordionDetails, withTransientProps)<{
  $compact?: boolean;
}>`
  padding: ${({ $compact }) => `${$compact ? "0 !important" : null}`};
`;
